import { copyParty } from '@/core';
import createSubOrder from '../createSubOrder';

export default function createTransporterOrder(order, vendor, etd, eta, despatchOption = 'despatchParty', deliveryOption = 'deliveryParty', customDespatchParty = null, customDeliveryParty = null, serviceCode = null) {
	let newOrder = {
		...createSubOrder(order),
		vendor,
		external: true,
		serviceCode
	};

	if (etd) {
		newOrder.etd = etd;
	}
	if (eta) {
		newOrder.eta = eta;
	}
	if (despatchOption === 'custom') {
		newOrder.despatchOption = 'custom';
		newOrder.despatchParty = copyParty(customDespatchParty);
	}
	if (deliveryOption === 'custom') {
		newOrder.deliveryOption = 'custom';
		newOrder.deliveryParty = copyParty(customDeliveryParty);
	}

	return newOrder;
}